import Nav from "./nav"
import Search from "./search"
import ContactForm from "./contact_form"
import Sliders from "./sliders"
import ProductFilters from "./product_filters"
import ProductCard from "./product-card"
import AddToCart from "./add_to_cart"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    ContactForm(jQuery)
    Sliders(jQuery)
    ProductFilters(jQuery)
    ProductCard(jQuery)
    AddToCart(jQuery)
})
